<template>
  <div id="bootTypeChange">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'bootTypeChange'
}
</script>


// WEBPACK FOOTER //
// src/views/bootTypeChange/BootTypeChange.vue